export default "__VITE_ASSET__dadfef59__"